import { canBridgeUse, useBridge } from './common';

const namespace = 'system';
export async function getAppInfo() {
    if (await canBridgeUse(namespace, 'getAppInfo')) {
        const nameSpaceApi = 'system.getAppInfo';
        return await useBridge(nameSpaceApi, {});
    }
    throw new Error('Bridge Unsupported: getAppInfo');
}


export async function getNetworkType() {
    if (await canBridgeUse(namespace, 'getNetworkType')) {
        const nameSpaceApi = 'system.getNetworkType';
        return await useBridge(nameSpaceApi, {});
    }
    throw new Error('Bridge Unsupported: getNetworkType');
}
